export default __webpack_public_path__ + "static/media/imgBacteriologia.b17ad7e8.png";